import { InjectionToken } from "@angular/core";

export const REFRESH_BLACK_LIST_URL = new InjectionToken<Array<RegExp | string>>(
  "REFRESH_BLACK_LIST_URL"
);

export const REFRESH_BLACK_LIST_URLS: Array<RegExp | string> = ["sign-in", "refresh"];
